export default "__VITE_ASSET__CwOo1B$3__"